export default {
  compress: '?x-oss-process=style/compress',
  'jpg-1x': '?x-oss-process=style/jpg-1x',
  'jpg-2x': '?x-oss-process=style/jpg-2x',
  'jpg-3x': '?x-oss-process=style/jpg-3x',
  '1x': '?x-oss-process=style/1x',
  '2x': '?x-oss-process=style/2x',
  '3x': '?x-oss-process=style/3x',
  menuList: [],
  detectionPackageList: [],
  goodsTypeList: [],
  chipType: ''
}
